"use client";

import { c as _c } from "react/compiler-runtime";
import { UserNav } from "@/components/user-nav";
import Link from "@/components/link";
import Image from "next/image";
import { useAppStore } from "@/lib/app-store";
import { Button } from "./ui/button";
import { Menu } from "lucide-react";
import { useCallback, useMemo, useState } from "react";
import { useUserSummary } from "@/lib/api/user";
import UserIcon from "./UserIcon";
import { NotificationBell } from "./notification-bell";
import { cn, useMediaQuery } from "@/lib/utils";
import { useTranslations } from "next-intl";
export default function Header(t0) {
  const $ = _c(41);
  const {
    className
  } = t0;
  const t = useTranslations();
  const title = useAppStore(_temp);
  const actions = useAppStore(_temp2);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = action => {
      setIsMenuOpen(false);
      action?.();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMenuAction = t1;
  let t2;
  if ($[1] !== actions) {
    t2 = actions?.map(action_0 => ({
      ...action_0,
      action: action_0.action ? () => handleMenuAction(action_0.action) : () => handleMenuAction()
    }));
    $[1] = actions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const menuActions = t2;
  let t3;
  if ($[3] !== actions) {
    t3 = actions?.map(_temp3);
    $[3] = actions;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const actions_markup = t3;
  let t4;
  if ($[5] !== actions) {
    t4 = actions?.map(_temp4);
    $[5] = actions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const actions_mobile_icons = t4;
  let t5;
  if ($[7] !== menuActions) {
    t5 = menuActions?.map(_temp5);
    $[7] = menuActions;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const actions_menu = t5;
  const {
    data: userData
  } = useUserSummary();
  const user = userData?.user;
  const isLargeScreen = useMediaQuery("(min-width: 1024px)");
  let t6;
  if ($[9] !== className) {
    t6 = cn("border-b border-border/40 bg-white dark:bg-black pt-[env(safe-area-inset-top)]", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link className="relative flex items-center space-x-2" href="/"><Image src="/logo-supreme.svg" unoptimized={true} width="64" height="51" alt="" /></Link>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = <div className="mr-4 flex items-center gap-3 min-w-0">{t7}<span className="text-xl font-bold text-nowrap truncate flex-[1_1_0]">{title}</span></div>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== actions_mobile_icons) {
    t9 = <div className="lg:hidden flex items-center gap-2">{actions_mobile_icons}</div>;
    $[14] = actions_mobile_icons;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== actions_markup) {
    t10 = <div className="hidden lg:flex items-center gap-2">{actions_markup}</div>;
    $[16] = actions_markup;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== user) {
    t11 = user && <NotificationBell />;
    $[18] = user;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isLargeScreen ? undefined : actions_menu;
  const t13 = !isLargeScreen;
  let t14;
  if ($[20] !== isLargeScreen || $[21] !== t || $[22] !== user) {
    t14 = isLargeScreen ? <Button variant="ghost" aria-label={t("nav.menu-open")} className="relative flex items-center gap-2 h-9 w-auto px-2">{user ? <UserIcon user={user} size={32} showInfo={false} /> : <span className="text-sm">?</span>}<Menu /></Button> : <Button size="icon" variant="ghost" aria-label={t("nav.menu-open")}><Menu /></Button>;
    $[20] = isLargeScreen;
    $[21] = t;
    $[22] = user;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== isLargeScreen || $[25] !== isMenuOpen || $[26] !== t12 || $[27] !== t13 || $[28] !== t14) {
    t15 = <UserNav actionsMenu={t12} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} showAvatar={t13} showUserInfo={isLargeScreen}>{t14}</UserNav>;
    $[24] = isLargeScreen;
    $[25] = isMenuOpen;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t15 || $[33] !== t9) {
    t16 = <nav className="flex flex-1 items-center justify-end space-x-2">{t9}{t10}{t11}{t15}</nav>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t15;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t8) {
    t17 = <div className="container mx-auto flex h-14 items-center">{t8}{t16}</div>;
    $[35] = t16;
    $[36] = t8;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t6) {
    t18 = <header className={t6}>{t17}</header>;
    $[38] = t17;
    $[39] = t6;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}
function _temp5(action_3, index_0) {
  const content_0 = <>{action_3.icon}<span>{action_3.title}</span></>;
  return <Button key={action_3.href ?? index_0} size="sm" variant="link" onClick={action_3.action} asChild={!!action_3.href} className="text-foreground">{action_3.href ? <Link key={action_3.href} href={action_3.href} className="justify-start">{content_0}</Link> : content_0}</Button>;
}
function _temp4(action_2, index) {
  return <Button key={action_2.href ?? index} size="icon" variant="ghost" aria-label={action_2.title} onClick={action_2.action} asChild={!!action_2.href}>{action_2.href ? <Link key={action_2.href} href={action_2.href} aria-label={action_2.title}>{action_2.icon}</Link> : action_2.icon}</Button>;
}
function _temp3(action_1) {
  const content = <>{action_1.icon}{action_1.title}</>;
  return <Button key={action_1.href} size="sm" variant="outline" onClick={action_1.action} asChild={!!action_1.href}>{action_1.href ? <Link key={action_1.href} href={action_1.href}>{content}</Link> : content}</Button>;
}
function _temp2(s_0) {
  return s_0.page?.actions;
}
function _temp(s) {
  return s.page?.title;
}